import { defineComponent as _defineComponent } from 'vue'
import handleImageAlt from '~/helpers/handleImageAlt';
import handleImageSrc from '~/helpers/handleImageSrc';
import { CdnImg } from '@webplatform/cdn-image';


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogProductCard',
  props: {
  image: {
    type: Object,
    default: () => {},
  },
  name: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  isNew: {
    type: Boolean,
    default: false,
  },
  link: {
    type: String,
    default: '',
  },
  tags: {
    type: Array,
    default: () => [],
  },
},
  setup(__props) {



return { __sfc: true,handleImageAlt, handleImageSrc, CdnImg }
}

})